export enum StudentStatusForBatch {
	Active = 'active',
	Inactive = 'Inactive',
}
